import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng-fe/ui_pc_ad';
import NewsLive from './newsLive';
import News from './news';
import Answer from './answer';
import List from './headline/list';

class LeftContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.col_L}>
                <NoSSR>
                    <Chip
                        id="256085"
                        type="recommend"
                        title="头条新闻"
                        groupName="正文"
                        content={content.headline}
                        position="relative"
                        translate="handleHeadlinePicData">
                        <List />
                    </Chip>
                </NoSSR>
                <div className={styles.space10} />
                <NewsLive content={content.newsLive} />
                {/* <div className={styles.space10} />
                <News content={content.news} />
                <div className={styles.space3} />
                <Answer content={content.answer} /> */}
                <div className={styles.ad}>
                    <NoSSR onSSR={<div className={styles.ad_box} />}>
                        <Ad content={content.leftAsideAd} styleName={styles.ad_box} />
                    </NoSSR>
                </div>
            </div>
        );
    }
}

export default LeftContent;
